import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { FullscreenExitOutlined, FullscreenOutlined, ToolOutlined } from '@ant-design/icons';
import { apiV2AirCompressorOverviewGetConfigPost } from '@maxtropy/device-customer-apis-v2';
import { useNavigate } from 'react-router-dom';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';
import { DEFAULT_OVERVIEW_TITLE } from '../../Config/utils';
import styles from './index.module.scss';

interface HeaderProps {
  isFullScreen: boolean;
  onToggleFullscreen: () => void;
}

const Header: React.FC<HeaderProps> = ({ isFullScreen, onToggleFullscreen }) => {
  const [time, setTime] = useState(() => dayjs().format('YYYY年M月D日 dddd HH:mm:ss'));
  const [title, setTitle] = useState(DEFAULT_OVERVIEW_TITLE);
  const navigate = useNavigate();
  const hasAirCompressorStationParameterConfiguration = useHasPermission(
    PermissionsType.B_AIR_COMPRESSOR_STATION_PARAMETER_CONFIGURATION
  );

  useEffect(() => {
    const timer = window.setInterval(() => {
      setTime(dayjs().format('YYYY年M月D日 dddd HH:mm:ss'));
    }, 1000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    apiV2AirCompressorOverviewGetConfigPost({})
      .then(res => {
        setTitle(res.title || DEFAULT_OVERVIEW_TITLE);
      })
      .catch(() => {
        setTitle(DEFAULT_OVERVIEW_TITLE);
      });
  }, []);

  return (
    <div className={styles.header}>
      <div className={styles.headerTime}>{time}</div>
      <div className={styles.headerTitle}>{title}</div>
      <div className={styles.headerActions}>
        {hasAirCompressorStationParameterConfiguration && (
          <div className={styles.btn} onClick={() => navigate('/power/monitoring/compressedAirOverview/config')}>
            <ToolOutlined />
            &nbsp;
            <span className={styles.text}>配置</span>
            <div className={styles.bottomLine} />
          </div>
        )}

        <div className={styles.btn} onClick={onToggleFullscreen}>
          {isFullScreen ? <FullscreenExitOutlined /> : <FullscreenOutlined />}
          &nbsp;
          <span className={styles.text}>{isFullScreen ? '退出' : '全屏'}</span>
          <div className={styles.bottomLine} />
        </div>
      </div>
    </div>
  );
};

export default Header;
